import React from "react";


import  Home  from "../Header/Home";
import  OMnie  from "../OMnie/OMnie";
import  Oferta from "../Oferta/Oferta";
import Opinie from '../Opinie/Opinie';
import JakPrzebiegaW from '../JakPrzebiegaW/JakPrzebiegaW';
import Footer from '../Footer/Footer';
import { Navbar } from "../../components";
import Instagram from "../Instagram/Instagram";




const Hom = () => {
    return (
        <>
            <Navbar />
            <Home />
            <OMnie />
            <Oferta />
            <Opinie />
            <JakPrzebiegaW />
            <Instagram />
            <Footer />
        </>

    );
};

export default Hom;
